import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { useTranslation } from 'react-i18next';
import HiddenLayout from './HiddenLayout';
import Blocked from './Icons/Blocked';
const DefaultBlockedOverlay = (_param)=>{
    var { deviation  } = _param, props = _object_without_properties(_param, [
        "deviation"
    ]);
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(HiddenLayout, _extends({
        deviation: deviation,
        icon: /*#__PURE__*/ React.createElement(Blocked, null),
        title: t('deviationview.blocked.default')
    }, props));
};
DefaultBlockedOverlay.displayName = 'DefaultBlockedOverlay';
export default DefaultBlockedOverlay;
